const maintenanceTimelineContent = {
  created: 'Mantenimiento creado.',
  to: 'por',
  from: 'de ',
  empty_value_1: 'ninguno',
  empty_value_2: 'ninguna',
  change_identifier: 'Cambió el identificador de',
  change_description: 'Cambió la descripción de',
  change_value: 'Cambió el valor de R$',
  change_company: 'Cambió la Empresa Responsable de',
  change_send_to_maintenance_date: 'Cambió la Fecha prevista de envió de mantenimiento',
  change_return_from_maintenance_date: 'Cambió la Fecha prevista de devolución de mantenimiento',
  change_warranty: 'Cambió el período de garantía',
  change_expiration: 'Cambió la fecha de vencimiento',
  file: 'El archivo',
  add_file: 'fue agregado.',
  delete_file: 'fue borrado.',
  change: 'Mantenimiento modificado.',
};

export default maintenanceTimelineContent;